<script setup>
import { storeToRefs } from 'pinia'
import { computed } from 'vue'
import { useAuthStore } from '~/stores/auth'
import { useMessageStore } from '~/stores/messages'

definePageMeta({
    pageName: 'centerCoupons'
})

// Fetch route
const route = useRoute()
const centerRoute = computed(() => route.params?.centerUid)

// Get center details
const { data: centerDetails, suspense: centerDetailSuspense } = useFetchCenterDetails(centerRoute.value)

// Initial fetch (consumer) coupons
const bearerToken = useState('state_bearerToken')
const oid = useState('state_userOid')

const { data: couponsData, suspense: couponListSuspense, isPlaceholderData: isCouponsPlaceholderData } = useFetchCoupons({
    centerRoute: centerRoute.value,
    bearerToken,
    oid
})

onServerPrefetch(async () => {
    await centerDetailSuspense()
    await couponListSuspense()
})

// Fetch messages
const messagesStore = useMessageStore()
const { messages: staticKeys } = storeToRefs(messagesStore)

// Define app download config
const commonAppContent = computed(() => {
    return {
        title: staticKeys.value?.account_gettheapp_headline,
        description: staticKeys.value?.account_gettheapp_copytext
    }
})

// Modal store
const modalStore = useModalStore()
const { toggleModal, addModalContent } = modalStore

// Show app teaser, depending on router query (appears if user clicks on universal or app link in newsletter etc. and gets redirected
const showAppTeaser = useRouteQuery('showModal')

if (showAppTeaser.value === 'appTeaser') {
    addModalContent(commonAppContent.value)

    toggleModal(true)
}

// Auth
const authStore = useAuthStore()
const { isLoggedIn } = storeToRefs(authStore)

const couponListConfig = computed(() => {
    return {
        items: couponsData.value,
        placeholder: isCouponsPlaceholderData.value,
        tracking: 'centerCoupons'
    }
})

// Track Page Load
trackPageLoad({
    title: TRACKING_CONSTANTS.TITLES.COUPONS_OVERVIEW,
    centerUid: centerDetails.value?.centerUid,
    centerName: centerDetails.value?.centerName,
    loginStatus: isLoggedIn.value ? TRACKING_CONSTANTS.MISC.LOGGED_IN : TRACKING_CONSTANTS.MISC.LOGGED_OUT
})

// Seo
useSeoMeta({
    title: () => `${staticKeys.value?.header_navigation_goodies_web} | ${centerDetails.value?.centerName}`
})
</script>

<template>
    <PageMainContainer :page-main-container-config="{ appFooter: true }">
        <CenterHeader />
        <ContentMainHeadline :content-main-headline-config="{ title: staticKeys?.coupon_overview_headline_web }" />
        <CouponList :coupon-list-config="couponListConfig" />
    </PageMainContainer>
</template>
